import helpEn from './en/en.json'
import helpAr from './ar/ar.json'
import helpEs from './es/es.json'
import helpDe from './de/de.json'
import helpIt from './it/it.json'
import helpFr from './fr/fr.json'
import helpPt from './pt/pt.json'
import helpEl from './el/el.json'
import helpBn from './bn/bn.json'
import helpSr from './sr/sr.json'
import helpCs from './cs/cs.json'
import helpPl from './pl/pl.json'
import helpHu from './hu/hu.json'
import helpSk from './sk/sk.json'
import helpRo from './ro/ro.json'
import helpBg from './bg/bg.json'
import helpMk from './mk/mk.json'
import helpSq from './sq/sq.json'

const HelpMessages = {
  en: { help: { ...helpEn } },
  ar: { help: { ...helpAr } },
  es: { help: { ...helpEs } },
  de: { help: { ...helpDe } },
  it: { help: { ...helpIt } },
  fr: { help: { ...helpFr } },
  pt: { help: { ...helpPt } },
  el: { help: { ...helpEl } },
  bn: { help: { ...helpBn } },
  sr: { help: { ...helpSr } },
  cs: { help: { ...helpCs } },
  pl: { help: { ...helpPl } },
  hu: { help: { ...helpHu } },
  sk: { help: { ...helpSk } },
  ro: { help: { ...helpRo } },
  bg: { help: { ...helpBg } },
  mk: { help: { ...helpMk } },
  sq: { help: { ...helpSq } },
}

export default HelpMessages
